import { http } from './config'
import authHeader from './auth-header';

export default {


    associados: (dataI, dataF, nomeEmpresa) => {
        const params = {
            'anoI': dataI,
            'anoF': dataF,
            'empresa': nomeEmpresa
        }
        return http.get('/ds/associados-total', {
           params: params,
           headers: authHeader()   
        })
    },

    funeral: (dataI, dataF, nomeEmpresa) => {
        const params = {
            'anoI': dataI,
            'anoF': dataF,
            'empresa': nomeEmpresa
        }
        return http.get('/ds/funeral-total', {
           params: params,
           headers: authHeader()   
        })
    },


    associados_csv: (dataI, dataF, nomeEmpresa) => {
    
            const converteParaNull = (valor) => {
                return valor === null ? 'NULL' : valor;
            };
            
            const params = {
                'anoI': dataI,
                'anoF': dataF,
                'empresa': nomeEmpresa
              };
           
              return http.get('/ds/associados-csv', {
                params: params,
                responseType: 'blob', 
                headers: authHeader() 
              });
              
    },

    contrato: (dataI, dataF, nomeEmpresa) => {
        const params = {
            'anoI': dataI,
            'anoF': dataF,
            'empresa': nomeEmpresa
        }
        return http.get('/ds/contratos-total', {
           params: params,
           headers: authHeader()   
        })
    },

    contrato_csv: (dataI, dataF, nomeEmpresa) => {
    
            const converteParaNull = (valor) => {
                return valor === null ? 'NULL' : valor;
            };
            
            const params = {
                'anoI': dataI,
                'anoF': dataF,
                'empresa': nomeEmpresa
              };
           
              return http.get('/ds/contratos-csv', {
                params: params,
                responseType: 'blob', 
                headers: authHeader() 
              });
              
    },

    parcelas: (dataI, dataF, nomeEmpresa) => {
        const params = {
            'anoI': dataI,
            'anoF': dataF,
            'empresa': nomeEmpresa
        }
        return http.get('/ds/parcelas-total', {
           params: params,
           headers: authHeader()   
        })
    },

    parcelas_csv: (dataI, dataF, nomeEmpresa) => {
    
            const converteParaNull = (valor) => {
                return valor === null ? 'NULL' : valor;
            };
            
            const params = {
                'anoI': dataI,
                'anoF': dataF,
                'empresa': nomeEmpresa
              };
           
              return http.get('/ds/parcelas-csv', {
                params: params,
                responseType: 'blob', 
                headers: authHeader() 
              });
              
    },

    funeral_csv: (dataI, dataF, nomeEmpresa) => {
    
        const converteParaNull = (valor) => {
            return valor === null ? 'NULL' : valor;
        };
        
        const params = {
            'anoI': dataI,
            'anoF': dataF,
            'empresa': nomeEmpresa
          };
       
          return http.get('/ds/funeral-csv', {
            params: params,
            responseType: 'blob', 
            headers: authHeader() 
          });
          
},
    

}
